import ImagesLoaded from 'vue-images-loaded'
export default ImagesLoaded



// WEBPACK FOOTER //
// ./src/directives/global/imagesLoaded.js